import React, { useEffect, useState } from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import { Card } from 'react-bootstrap';
import axios from 'axios';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TinyBarChart = React.memo(() => {
  const [chartData, setChartData] = useState({
    labels: [],
    series: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/status`);
        const stats = res.data.dailyStats;

        const labels = stats.map(day =>
          new Date(day.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
        );

        const series = [
          {
            label: 'Total Messages',
            data: stats.map(day => day.totalMessages),
          },
          {
            label: 'Total Tasks',
            data: stats.map(day => day.totalTasks),
          },
          {
            label: 'Completed Tasks',
            data: stats.map(day => day.completedTasks),
          },
          {
            label: 'Not Completed',
            data: stats.map(day => day.notCompletedTasks),
          },
          {
            label: 'Avg Delay (hrs)',
            data: stats.map(day => day.avgReplyDelay),
          },
        ];

        setChartData({ labels, series });
      } catch (err) {
        console.error('Failed to fetch 14-day chart data', err);
      }
    };

    fetchData();
  }, []);

  return (
    <Card className="mb-4" style={{ height: '65vh' }}>
      <Card.Body className="p-3">
        <div style={{ height: '66vh' }}>
          {chartData.labels.length > 0 ? (
            <BarChart
              style={{ height: '61vh' }}
              xAxis={[{ data: chartData.labels, scaleType: 'band' }]}
              series={chartData.series}
              minBarHeight={4} 
            />

          ) : (
            <SkeletonTheme baseColor="#e0e0e0" highlightColor="#f5f5f5">
              <Skeleton height="90%" />
              <Skeleton height={20} width="50%" style={{ marginTop: '10px' }} />
            </SkeletonTheme>
          )}
        </div>
      </Card.Body>
    </Card>
  );
});

export default TinyBarChart;